import React, { useEffect, useState } from 'react'
import * as Styles from './MoreLiveRoom.style'
import WKInfiniteScroll from '@/components/WKInfiniteScroll/WKInfiniteScroll'
import { ILiveRoomItem, SEARCH_TYPE } from '../../../services/Modules/searchServer'
import HttpServer from '@/services/server'
import { RouteProps } from 'react-router'
import Loading from '@/components/Loading/Loading'
import { getLocationParamValue } from '../../../utils/tools'
function goLiveRoom(roomId: number) {
    if (/lycheer/.test(navigator.userAgent.toLocaleLowerCase())) {
        window.location.href = `lizhiweike://liveroom?liveroom_id=${roomId}`
    } else {
        window.location.href = `/liveroom/${roomId}`
    }
}

export default function MoreLiveRoom(props: RouteProps) {
    const keyword = decodeURIComponent(getLocationParamValue('keyword') || '')
    if (!keyword) {
        return null
    }
    const [ isLoading, setIsloading ] = useState(false)
    const [ hasMore, setHasMore ] = useState(false)
    const [ list, setList ] = useState<ILiveRoomItem[]>([])
    const [ page, setPage ] = useState(1)
    const [ isInited, setIsInited ] = useState(false)
    const size = 10

    useEffect(() => {
        getList()
        .then(() => {
            setIsInited(true)
        })
    }, [])

    async function getList() {
        try {
            setIsloading(true)
            const data = await HttpServer.getSearch<ILiveRoomItem>({ keyword, type: SEARCH_TYPE.LIVE_ROOM, offset: (page - 1) * size})
            setList([...list, ...data.data.data.records])
            setHasMore(data.data.data.has_more)
            setPage(page + 1)
            setIsloading(false)
        } catch (error) {
            console.log(error.message)
        }
    }
    return (
        <div className={Styles.container} >
            {
                isInited
                ? (
                    <div className={Styles.list}>
                    {
                        list.map(item => (
                            <div key={item.id} className={Styles.listItem} onClick={() => goLiveRoom(item.id)}>
                                <div className={Styles.wrap}>
                                    <div className={Styles.leftSide}>
                                        <img className={Styles.avatar} src={item.avatar_url} alt=""/>
                                    </div>
                                    <div className={Styles.rightSide}>
                                        <div className={Styles.title}>
                                            {item.name}
                                        </div>
                                        <div className={Styles.personNumb}>
                                            {item.fans_count >= 10000 ? (item.fans_count / 10000).toFixed(2) + '万' : item.fans_count}<span>人关注</span>
                                        </div>
                                        <div className={Styles.desc}>
                                            {item.description}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )
                        )
                        }
                        <WKInfiniteScroll
                            onTouchBottom={getList} // 到达底部执行的方法
                            isStop={isLoading} // 暂停执行onTouchBottom，一般是正在请求接口时触发
                            distance={200} // 距离底部多少px触发
                            isKill={!hasMore} // 不再监听滚动，一般是传!has_more
                            isShowLoading={true} // 请求数据的时候（isStop）是否显示菊花
                        />
                    </div>
                )
                : <Loading />
            }

        </div>
    )
}



// WEBPACK FOOTER //
// ./src/views/SearchResult/MoreLiveRoom/MoreLiveRoom.tsx